import React, { useEffect, useState, useRef } from 'react'
import Header from '../components/home/Header'
import ValoresApi from '../services/robinhood/ValoresApi';
import MunicipioSelecionado from '../components/extratos/MunicipioSelecionado';
import MunicipioSelecionarModal from '../components/municipios/MunicipioSelecionarModal';
import ContentBoxValores from '../components/extratos/ContentBoxValores';
import RelatorioChart from '../components/extratos/RelatorioChart';
import TransferenciasGlobaisAnos from '../components/transferenciasGlobais/TransferenciasGlobaisAnos';
import Preloader from '../components/home/Preloader';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Meses from '../services/Meses';
import CategoriasCount from '../components/categorias/CategoriasCount';
import CategoriasApi from '../services/robinhood/CategoriasApi';
import CategoriasNavMenu from '../components/categorias/CategoriasNavMenu';
import TableExtratoAnualConservacoes from './TableExtratoAnualConservacoes';
import ListaLinhaValorDestacado from 'components/extratos/ListaLinhaValorDestacado';
import DownloadTable from '../components/extratos/DownloadTable';


export default function ExtratoAnual() {
    const location = useLocation();
    const navigate = useNavigate();
    const [valores, setValores] = useState([]);
    const [indicadores, setIndicadores] = useState({ 'indices': { 'indice_participacao': [] } });
    const [indicadoresIndices, setIndicadoresIndices] = useState([]);
    const [indicadoresTransferencias, setIndicadoresTransferencias] = useState([]);
    const [indicadoresDadosBasicos, setIndicadoresDadosBasicos] = useState([]);
    const [indicadoresConservacoes, setIndicadoresConservacoes] = useState([]);
    const [categoriasResponse, setCategoriasResponse] = useState([]);
    const [valoresIndices, setValoresIndices] = useState([]);
    const [valoresTransferencias, setValoresTransferencias] = useState([]);
    const [valoresDadosBasicos, setValoresDadosBasicos] = useState([]);
    const [valoresSaneamento, setValoresSaneamento] = useState([]);
    const [valoresConservacoes, setValoresConservacoes] = useState([]);
    const [anos, setAnos] = useState(localStorage.getItem('valores_anos') ? JSON.parse(localStorage.getItem('valores_anos')) : [{ 'ano': new Date().getFullYear() }]);
    const [ano, setAno] = useState(new Date().getFullYear());
    const [municipio, setMunicipio] = useState(localStorage.getItem('municipio') ? JSON.parse(localStorage.getItem('municipio')) : { 'id': null, 'municipio': 'NÃO INFORMADO' });
    const [loaded, setLoaded] = useState(false);
    const categorias = { 'indices': 1, 'transferencias': 2, 'dados_basicos': 3, 'saneamentos': 4, 'conservacoes': 5 };
    const tableRefInices = useRef();
    const tableRefTransferencias = useRef();


    useEffect(() => {
        if (!municipio.id) {
            navigate('/municipios');
        }
        document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
        new CategoriasApi().all().then(response => setCategoriasResponse(response));
    }, []);

    useEffect(() => {
        if (municipio.id && ano > 0)
            getValores(ano, municipio.id);
    }, [ano, municipio]);

    const handlerMunicipio = (_municipio) => {
        if (!_municipio.id) {
            return;
        }

        setMunicipio(_municipio);
        localStorage.setItem('municipio', JSON.stringify(_municipio));
        const storage = JSON.parse(localStorage.getItem('municipios'));
        const municipiosFilter = storage.filter(item => item.id != _municipio.id);
        municipiosFilter.push(_municipio);
        municipiosFilter.reverse();
        localStorage.setItem('municipios', JSON.stringify(municipiosFilter));
    }

    const uniqueById = (data, key) => {
        return [
            ... new Map(
                data.map(x => [key(x), x])
            ).values()
        ];
    }

    const getValores = async (_ano, _municipio_id) => {

        setLoaded(false);
        await new ValoresApi().extratoAnual(_ano, _municipio_id).then(response => {
            let categoriasValores = {
                indices: [],
                transferencias: [],
                dadosBasicos: [],
                conservacoes: [],
            };
            let categoriasIndicadores = {
                indices: [],
                transferencias: [],
                dadosBasicos: [],
                conservacoes: [],
            };

            let indices_participacao = [];

            if (response.indicadores) {

                for (let i = 0; i < response.indicadores.length; i++) {
                    const indicador = response.indicadores[i];
                    switch (indicador.categoria_id) {
                        case categorias.indices:
                            categoriasIndicadores.indices.push(indicador);
                            break;
                        case categorias.transferencias:
                            categoriasIndicadores.transferencias.push(indicador);
                            break;
                        case categorias.dados_basicos:
                            categoriasIndicadores.dadosBasicos.push(indicador);
                            break;
                        case categorias.conservacoes:
                            categoriasIndicadores.conservacoes.push(indicador);
                            break;

                        default:
                            break;
                    }
                }
                setIndicadoresIndices(categoriasIndicadores.indices);
                setIndicadoresTransferencias(categoriasIndicadores.transferencias);
                setIndicadoresDadosBasicos(categoriasIndicadores.dadosBasicos);
                // setIndicadoresConservacoes(categoriasIndicadores.conservacoes);
            }

            if (response.valores) {

                response.valores.map(valor => {
                    switch (parseInt(valor.categoria_id)) {
                        case categorias.indices:
                            categoriasValores.indices.push(valor);
                            if (valor.indicador == 'ind_idx') {
                                indices_participacao.push(valor);
                            }
                            break;
                        case categorias.transferencias:
                            categoriasValores.transferencias.push(valor);
                            break;
                        case categorias.dados_basicos:
                            categoriasValores.dadosBasicos.push(valor);
                            break;
                        case categorias.conservacoes:
                            categoriasValores.conservacoes.push(valor);
                            break;
                        default:
                            break;
                    }
                });
                setValoresIndices(categoriasValores.indices);
                setValoresTransferencias(categoriasValores.transferencias);
                setValoresDadosBasicos(categoriasValores.dadosBasicos);
                // setValoresConservacoes(categoriasValores.conservacoes);
                setIndicadores({ indices: { indice_participacao: indices_participacao } });

            }
        });
        await new ValoresApi().extratoAnualConservacoes(_ano, _municipio_id).then(response => {
            setValoresConservacoes(response);
        });

        setLoaded(true);
        scrollWindow();
    }

    const handlerAno = (_ano) => {
        setAno(_ano);
    }

    const scrollWindow = () => {
        let mybutton = document.getElementById("buttomScrollUp");
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            if (document.documentElement.scrollTop > 60) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    const TableRows = (_valores, _indicadores, _categoria) => {
        let linhas = [];
        const coresDestaque = ['#E91E63', '#8BC34A', '#BA3BD0', '', '#FDD748'];
        let totais = { 'indices': { 'ind_idx': [] } };

        for (let i = 0; i < _indicadores.length; i++) {
            const indicador = _indicadores[i];
            let linha = { indicador_id: indicador.indicador_id, indicador_nome: indicador.nome, meses: [], categoria_id: indicador.categoria_id, valorTotal: 0.0000, destacado: indicador.destacado };

            for (let mes_id = 1; mes_id < 13; mes_id++) {
                _valores.map((valor, j) => {
                    if (valor.indicador_id == indicador.indicador_id) {
                        let mes = { mes_id: mes_id, valor: null };
                        if (valor.mes_id == mes_id) {
                            mes.valor = valor.valor;
                            linha.meses.push(mes);
                            if (valor.valor) {
                                let floatValor = parseFloat(String(valor.valor).replaceAll('.', '').replaceAll(',', '.'));
                                if (!isNaN(floatValor)) {
                                    linha.valorTotal = (linha.valorTotal + floatValor);
                                }

                            }
                        }
                    }
                });
            }
            linhas.push(linha);
        }

        return <>
            {linhas.map(linha => {
                return <tr key={Math.random()}>
                    <td className='text-left'> <ListaLinhaValorDestacado valor={linha.indicador_nome} destacado={linha.destacado} cor={coresDestaque[(linha.categoria_id - 1)]} />  </td>
                    {Meses.map(iMes => {
                        let td = <td className='text-right'> </td>;
                        linha.meses.map((mes) => {
                            if (mes.mes_id == iMes.id)
                                td = <td className='text-right'> {mes.valor}</td>
                        })
                        return td;
                    }
                    )}
                    {/* {linha.categoria_id == categorias.indices
                        ? < td className='text-right bg-light' > {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 8 }).format(linha.valorTotal)} </td>
                        : < td className='text-right bg-light' > {Intl.NumberFormat('pt-BR').format(Math.round((linha.valorTotal + Number.EPSILON) * 100) / 100)} </td>} */}
                    {linha.categoria_id == categorias.transferencias && <td className='text-right bg-light' > {Intl.NumberFormat('pt-BR').format(Math.round((linha.valorTotal + Number.EPSILON) * 100) / 100)} </td>}
                </tr >
            })
            }
        </>

    }

    const TableFooter = (_valores, _bgColor, _categoria) => {
        let totaisMeses = [];
        let totalTransferido = 0;
        for (let mes_id = 1; mes_id < 13; mes_id++) {
            let soma = 0.0000;
            _valores.map((valor) => {
                if (valor.mes_id == mes_id) {
                    if (valor.valor) {
                        let floatValor = parseFloat(String(valor.valor).replaceAll('.', '').replace(',', '.'));
                        if (!isNaN(floatValor)) {
                            soma = soma + floatValor;
                        }
                    }
                }
            });
            totaisMeses.push(soma);
        }

        totaisMeses.forEach(soma => {
            totalTransferido = totalTransferido + soma;
        });

        return <>
            <tr key={Math.random()}>
                <td class={`text-left ${_bgColor}`}>TOTAL <small style={{ fontSize: '10px' }}>(MENSAL)</small></td>
                {totaisMeses.map(mes => {
                    return _categoria == categorias.indices
                        ? <td className='text-right bg-light'> {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 8 }).format(mes)} </td>
                        : <td className='text-right bg-light'> {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(Math.round((mes + Number.EPSILON) * 100) / 100)} </td>
                }

                )}
                <th className='text-right text-accent-1' style={{ backgroundColor: '#ECECEC' }}> {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(Math.round((totalTransferido + Number.EPSILON) * 100) / 100)} </th>
            </tr>
        </>
    }

    const TableValores = (_valores, _indicadores, _bgColor, _categoria = null) => {
        let template = _valores[0];
        template.mes = "anual";
        return <>
            <DownloadTable tableRef={_categoria == 1 ? tableRefInices : tableRefTransferencias} template={template} />
            <table ref={_categoria == 1 ? tableRefInices : tableRefTransferencias} class="table table-sm small table-hover" key={Math.random()} id={_categoria} >
                <thead>
                    <th class="text-left">CRITÉRIO</th>
                    <th class="text-right">JANEIRO</th>
                    <th class="text-right">FEVEREIRO</th>
                    <th class="text-right">MARÇO</th>
                    <th class="text-right">ABRIL</th>
                    <th class="text-right">MAIO</th>
                    <th class="text-right">JUNHO</th>
                    <th class="text-right">JULHO</th>
                    <th class="text-right">AGOSTO</th>
                    <th class="text-right">SETEMBRO</th>
                    <th class="text-right">OUTUBRO</th>
                    <th class="text-right">NOVEMBRO</th>
                    <th class="text-right">DEZEMBRO</th>
                    {_categoria == categorias.transferencias && <th class={`text-right ${_bgColor}`}>TOTAL <small style={{ fontSize: '10px' }}>(ANUAL)</small></th>}
                </thead>
                <tbody>
                    {TableRows(_valores, _indicadores, _categoria)}
                    {_categoria == categorias.transferencias && TableFooter(_valores, _bgColor, _categoria)}

                </tbody>
            </table>
        </>
    }

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return <>
        <div className='container-fluid'>
            <Header>
                <h5 style={{ marginLeft: '10px', marginBottom: '20px' }}> <i className='zmdi zmdi-city-alt'></i> EXTRATO ANUAL DE {ano} </h5>
                <section className='container-fluid'>
                    <div className='row'>
                        <MunicipioSelecionado municipio={municipio} />
                    </div>
                    <div className='row'>
                        <TransferenciasGlobaisAnos anos={anos} handlerAno={handlerAno} ano={ano} backgroundColor={'bg-blue-grey'} retornar={false} />
                    </div>
                </section>
            </Header>

            <section className='content' style={{ marginTop: '-20px' }}>
                <div className='row'>
                    <div className='col-12'>
                        <CategoriasNavMenu
                            valores={{
                                'indices': valoresIndices.length,
                                'transferencias': valoresTransferencias.length,
                                'dadosBasicos': valoresDadosBasicos.length,
                                'dadosBasicosSaneamento': 0,
                                'dadosBasicosConservacao': valoresConservacoes.length,
                            }}
                        />
                    </div>
                </div>
                {(valoresIndices.length == 0 && valoresTransferencias.length == 0 && valoresDadosBasicos.length == 0 && valoresConservacoes.length == 0)
                    ? <section className='container-fluid'> <span className='content' style={{ marginTop: '-20px' }}> <h6 className='text-muted'><i class="zmdi zmdi-info"></i> NÃO FORAM ENCONTRADOS DADOS REFERENTES AO PERÍODO SELECIONADO </h6></span> </section>
                    : null}
            </section>
            <section className='content' style={{ marginTop: '-20px', display: loaded ? 'block' : 'none' }} >

                {Object.entries(valoresTransferencias).length > 0 &&
                    <ContentBoxValores titulo="TRANSFERÊNCIAS" subtitulo={` EVOLUÇÃO DAS TRANSFERÊNCIAS DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='yellowgreen'>
                        <RelatorioChart
                            ano={ano}
                            valores={valoresTransferencias}
                            label={''} titulo={''} subtitulo={''} backgroundColor={'#8BC34A'} key={Math.random()} >
                        </RelatorioChart>
                        {TableValores(valoresTransferencias, indicadoresTransferencias, 'bg-light-green', categorias.transferencias)}
                    </ContentBoxValores>}

                {Object.entries(valoresIndices).length > 0 &&
                    <ContentBoxValores titulo="ÍNDICES" subtitulo={` EVOLUÇÃO DOS ÍNDICES DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='pink'>
                        {/* {JSON.stringify(indicadores.indices.indice_participacao)} */}
                        <RelatorioChart
                            ano={ano}
                            valores={indicadores.indices.indice_participacao}
                            label={''} titulo={''} subtitulo={''} backgroundColor={'#E91E63'} key={Math.random()} >
                        </RelatorioChart>
                        {TableValores(valoresIndices, indicadoresIndices, 'bg-pink', categorias.indices)}
                    </ContentBoxValores>}



                {/* {Object.entries(valoresDadosBasicos).length > 0 &&
                <ContentBoxValores titulo="DADOS BASICOS" subtitulo={` EVOLUÇÃO DOS DADOS BASICOS DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='purple'>
                    <RelatorioChart
                        ano={ano}
                        valores={valoresDadosBasicos}
                        label={''} titulo={''} subtitulo={''} backgroundColor={'#BA3BD0'} key={Math.random()} >
                    </RelatorioChart>
                    {TableValores(valoresDadosBasicos, indicadoresDadosBasicos, 'bg-purple', categorias.dados_basicos)}
                </ContentBoxValores>} */}

                {/* {Object.entries(valoresConservacoes).length > 0 &&
                <div id='CONSERVACOES'>
                    <ContentBoxValores titulo="UNIDADES DE CONSERVAÇÕES" subtitulo={` EVOLUÇÃO DAS UNIDADES DE CONSERVAÇÕES DO MUNICÍPIO DE ${municipio.municipio} DURANTE O ANO DE ${ano}`} color='#FFC107'>
                        <TableExtratoAnualConservacoes valores={valoresConservacoes} key={Math.random()}></TableExtratoAnualConservacoes>
                    </ContentBoxValores>
                </div>
            } */}
            </section>
        </div>
        <MunicipioSelecionarModal titulo='ALTERAR MUNICÍPIO' handlerMunicipio={handlerMunicipio} navigate={''} />

        <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
            <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
        </a>

    </>
}